import { defineElement, html, TemplateElement } from '@webtides/element-js';
import InputEvents from '../events/InputEvents';
import '../../arrow-box/arrow-box';
import styles from './_input-range.css';

export default class InputRange extends TemplateElement {
    constructor() {
        super({ shadowRender: false, styles: [styles] });
    }

    properties() {
        return {
            min: 0,
            max: 500,
            minValue: 0,
            maxValue: 500,
            step: 1,
            unit: '',
            primaryName: 'primaryName',
            secondaryName: 'secondaryName',
            showIndicator: true,
            showMinValue: true,
            showMaxValue: true,
            valueNumberFormatter: null,
        };
    }
    connected() {
        this.requestUpdate();
    }

    afterUpdate() {
        this.updateCSSProperties();
    }

    updateCSSProperties() {
        //calc style props from values
        const minPercentage = 100 * ((this.minValue - this.min) / (this.max - this.min)) + 1 + '%';
        const maxPercentage = 100 * ((this.maxValue - this.min) / (this.max - this.min)) - 1 + '%';
        this.style.setProperty('--low', minPercentage);
        this.style.setProperty('--high', maxPercentage);
        //notify observer
        if (this.showIndicator) {
            this.$refs.low.style.setProperty('--arrow-position', minPercentage);
            this.$refs.high.style.setProperty('--arrow-position', maxPercentage);
        }
    }

    events() {
        return {
            input: {
                input: () => {
                    //get values from DOM in event case
                    this.minValue = Math.min(this.$refs.primary.value, this.$refs.secondary.value);
                    this.maxValue = Math.max(this.$refs.primary.value, this.$refs.secondary.value);
                },
                change: () => {
                    this.dispatch(InputEvents.INPUT_RANGE_CHANGE, { min: this.minValue, max: this.maxValue }, true);
                },
            },
        };
    }

    watch() {
        return {
            minValue: () => {
                this.$refs.primary.value = this.minValue;
            },
            maxValue: () => {
                this.$refs.secondary.value = this.maxValue;
            },
        };
    }

    renderValue(value) {
        if (typeof this.valueNumberFormatter === 'function') {
            return html` ${this.valueNumberFormatter(value)} `;
        }
        return html` ${value} ${this.unit} `;
    }

    template() {
        // inputs value needs to be set as the last attribute otherwise it will cause a range error and display wrong initial value
        return html`
            <div class="${this.showIndicator ? 'pt-12' : ''}">
                ${this.showIndicator
                    ? html`
                          <arrow-box ref="low" class="value-low whitespace-no-wrap"
                              >${this.renderValue(this.minValue)}</arrow-box
                          >
                          <arrow-box ref="high" class="value-high whitespace-no-wrap"
                              >${this.renderValue(this.maxValue)}</arrow-box
                          >
                      `
                    : ''}

                <div class="slider">
                    <input
                        class="primary"
                        ref="primary"
                        type="range"
                        step="1"
                        name="${this.primaryName}"
                        min="${this.min}"
                        max="${this.max}"
                        value="${this.minValue}"
                    />
                    <input
                        class="secondary"
                        ref="secondary"
                        type="range"
                        step="1"
                        name="${this.secondaryName}"
                        min="${this.min}"
                        max="${this.max}"
                        value="${this.maxValue}"
                    />
                </div>

                <div class="value-info flex justify-between font-medium">
                    ${this.showMinValue ? html` <div class="min-value">${this.renderValue(this.min)}</div> ` : ''}
                    ${this.showMaxValue ? html` <div class="max-value">${this.renderValue(this.max)}</div> ` : ''}
                </div>
            </div>
        `;
    }
}

defineElement('input-range', InputRange);
